"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityRfpClientContactInfluencers = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_rfp_client_contact_details_entity_1 = require("./opportunity-rfp-client-contact-details.entity");
let OpportunityRfpClientContactInfluencers = class OpportunityRfpClientContactInfluencers {
};
exports.OpportunityRfpClientContactInfluencers = OpportunityRfpClientContactInfluencers;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpClientContactInfluencers.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "client_contact_id", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpClientContactInfluencers.prototype, "clientContactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "influencer_contact_id", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpClientContactInfluencers.prototype, "influencerContactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_rfp_client_contact_details_entity_1.OpportunityRfpClientContactDetail, (contact) => contact.clientContactInfluencers),
    (0, typeorm_1.JoinColumn)({ name: "client_contact_id", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof opportunity_rfp_client_contact_details_entity_1.OpportunityRfpClientContactDetail !== "undefined" && opportunity_rfp_client_contact_details_entity_1.OpportunityRfpClientContactDetail) === "function" ? _a : Object)
], OpportunityRfpClientContactInfluencers.prototype, "clientContact", void 0);
exports.OpportunityRfpClientContactInfluencers = OpportunityRfpClientContactInfluencers = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "opportunity_rfp_client_contact_influencers" })
], OpportunityRfpClientContactInfluencers);
